import { useState, useEffect } from 'react';
import { getAdminCompanyNames } from '../adminApi';

let _cache = null;

export function useCompanyNames() {
  const [names, setNames] = useState(_cache || {});

  useEffect(() => {
    if (_cache) return;
    getAdminCompanyNames()
      .then(data => { _cache = data; setNames(data); })
      .catch(() => {});
  }, []);

  return names;
}

export function resolveCompanyName(names, companyId) {
  if (!companyId) return '—';
  if (names[companyId]) return names[companyId];
  return companyId.length > 18
    ? companyId.slice(0, 8) + '…' + companyId.slice(-4)
    : companyId;
}
